var _Row;
import { useMediaQuery } from "@crehana/react-hooks";
import { Col, Container, Row, Skeleton } from "@crehana/ui";
import NewCoursesSliderSkeleton from "../../../../../components/NewCoursesSlider/NewCoursesSliderSkeleton";
import { useLearnLastActivityContext } from "../../../../../hooks";
import { jsx as _jsx } from "react/jsx-runtime";
var UserWithoutEnrollmentSkeleton = function UserWithoutEnrollmentSkeleton(_ref) {
  var withContainer = _ref.withContainer,
    dataTestId = _ref['data-testid'];
  var _useMediaQuery = useMediaQuery('sm'),
    isSm = _useMediaQuery.matches;
  var _useLearnLastActivity = useLearnLastActivityContext(),
    isDark = _useLearnLastActivity.isDark,
    containerType = _useLearnLastActivity.containerType;
  var renderSkeleton = function renderSkeleton(testId) {
    if (isSm) {
      return _Row || (_Row = /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          sm: 12,
          children: /*#__PURE__*/_jsx(NewCoursesSliderSkeleton, {})
        })
      }));
    }
    return /*#__PURE__*/_jsx(Skeleton, {
      "data-testid": testId,
      className: "h-full rounded-5 w-full",
      style: {
        height: '344px',
        maxHeight: '344px'
      },
      isDark: isDark
    });
  };
  if (withContainer) {
    return /*#__PURE__*/_jsx(Container, {
      type: containerType,
      "data-testid": dataTestId,
      children: renderSkeleton()
    });
  }
  return renderSkeleton(dataTestId);
};
export default UserWithoutEnrollmentSkeleton;